import { render, staticRenderFns } from "./formTemplateModal.vue?vue&type=template&id=55108f74&scoped=true&"
import script from "./formTemplateModal.vue?vue&type=script&lang=js&"
export * from "./formTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./formTemplateModal.vue?vue&type=style&index=0&id=55108f74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55108f74",
  null
  
)

export default component.exports